<template>
  <div class="cursor-pointer">
    <div class="hr-menu"></div>
    <div class="flex algin-center justify-content-between my-15">
      <div @click="activeMenu('order')" class="flex algin-center">
        <div style="width:31px;">
          <img :src="bg.icon_order" alt="" />
        </div>
        <span class="fw-550 c-caption">{{ $t("wap.text55") }}</span>
      </div>
      <img :src="bg.icon_drop_right" alt="" />
    </div>
    <div class="hr-menu"></div>
    <div class="flex algin-center justify-content-between my-15">
      <div @click="activeMenu('update-profile')" class="flex algin-center">
        <div style="width:31px;">
          <img :src="bg.icon_user_profile" alt="" />
        </div>

        <span class="fw-550  c-caption">{{ $t("updateInfoUser") }}</span>
      </div>
    </div>
    <div class="hr-menu"></div>

    <div
      v-if="!getToken().bank_id"
      @click="activeMenu('logout')"
      class="flex algin-center justify-content-between my-15"
    >
      <div class="flex algin-center">
        <div style="width:31px;">
          <img :src="icons.LogoutIcon" alt="" />
        </div>
        <span class="fw-550 c-caption" style="color: rgba(227, 29, 66, 1);">{{
          $t("wap.text56")
        }}</span>
      </div>
    </div>
    <div class="hr-menu"></div>
  </div>
</template>

<script>
import { decodeToken, getBackGround, getToken } from "@/utils/wapAuth";
import ArrowRightIcon from "@/assets/img/iconV2/arrow-right.svg";
import LogoutIcon from "@/assets/img/iconV2/logout.svg";
import StarIcon from "@/assets/img/iconV2/star.svg";
import UserIcon from "@/assets/img/iconV2/user.svg";
import OrderIcon from "@/assets/img/iconV2/order_icon.svg";
import { getInfo } from "@/utils/auth";
import { mapActions } from "vuex";

export default {
  components: {},
  bodyClass: "menu-profile-page",
  props: {},
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
  data() {
    return {
      bg: getBackGround(),
      icons: {
        ArrowRightIcon,
        UserIcon,
        StarIcon,
        LogoutIcon,
        OrderIcon
      },
      images: {
        DefaultAvatar:
          "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
      }
    };
  },

  watch: {},
  methods: {
    decodeToken,
    ...mapActions(["setTitleDialogUpdateInfo"]),
    getToken,
    activeMenu(type) {
      if (!getInfo()) {
        this.$store.dispatch("showLoginDialog");
        return;
      }
      if (type != "update-profile")
        this.$store.dispatch("setShowProfile", false);
      switch (type) {
        case "order":
          this.$router.push("/wap/history");
          break;
        case "logout":
          this.handleLogout();
          break;
        case "update-profile":
          this.$store.dispatch("setShowUpdateInfo", true);
          this.setTitleDialogUpdateInfo(this.$t("accountInfo"));
          break;
        default:
          break;
      }
    },
    handleLogout() {
      this.$store.dispatch("disconnectChat");
      window.localStorage.clear("info");
      window.location.reload();
    }
  }
};
</script>
<style lang="scss"></style>

<style scoped>
.my-15 {
  margin-top: 15px;
  margin-bottom: 15px;
}
.hr-menu {
  background-color: rgba(219, 219, 219, 1);
  height: 1px;
  width: 100%;
}
.divider-view {
  height: 10px !important;
  width: 100%;
  background-color: #e3e3e3;
  margin: 30px 0;
}

.top-spacing {
  padding-top: 100px;
}

.divider-view {
  height: 1px;
  width: 100%;
  margin-bottom: 10px;
  background-color: #ececec;
}

.px-20 {
  padding-left: 20px;
  padding-right: 20px;
}

@media screen and (min-width: 0px) and (max-width: 769px) {
  .top-spacing {
    padding-top: 60px !important;
  }
}
</style>

<style lang="scss">
$divider-color: #d9d9d9;

.divider-view-top {
  height: 15px;
  width: 100%;
}

.column {
  flex-direction: column;
}
.desktop {
  display: block;
}
.mobile {
  display: none;
}
.uppercase {
  text-transform: uppercase;
}
.full-width {
  width: 100%;
}

@media screen and (min-width: 0px) and (max-width: 480px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
}
@media screen and (min-width: 0px) and (max-width: 769px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
}
@media screen and (min-width: 769px) and (max-width: 980px) {
  .top-spacing {
    padding-top: 60px !important;
  }
}
</style>
